import React from 'react'
import {Route, Switch} from 'react-router-dom'
import {isObvioApp} from 'lib/url'
import {useOrganizationUrl} from 'organization/url'
import OrganizationProvider from 'organization/OrganizationProvider'
import OrganizationRoutes from 'organization/Routes'
import ObvioRoutes, {obvioRoutes, DOWNLOAD_REDIRECT_URL} from 'obvio/Routes'
import ExternalRedirect from 'obvio/ExternalRedirect'
import {AutoRefreshEvent, DomainEventProvider} from 'Event/EventProvider'
import EventRoutes from 'Event/Routes'
import AuthTokenHandler from 'Event/auth/AuthTokenHandler'
import EditModeProvider from 'Event/EditModeProvider'
import DateProvider from 'lib/date-time/DateProvider'
import {AdminDeepLinkProvider} from 'DeepLinkProvider'

export default function Routes() {
  if (isObvioApp()) {
    return (
      <Switch>
        <Route path={obvioRoutes.download}>
          <ExternalRedirect to={DOWNLOAD_REDIRECT_URL} />
        </Route>
        <Route>
          <AdminDeepLinkProvider>
            <AdminRoutes />
          </AdminDeepLinkProvider>
        </Route>
      </Switch>
    )
  }

  return (
    <DomainEventProvider>
      <AutoRefreshEvent>
        <AuthTokenHandler>
          <EditModeProvider>
            <EventRoutes />
          </EditModeProvider>
        </AuthTokenHandler>
      </AutoRefreshEvent>
    </DomainEventProvider>
  )
}

function AdminRoutes() {
  const {isOrganizationRoute} = useOrganizationUrl()

  return (
    <Switch>
      <Route>
        {isOrganizationRoute ? (
          <OrganizationProvider>
            <OrganizationRoutes />
          </OrganizationProvider>
        ) : (
          <DateProvider>
            <ObvioRoutes />
          </DateProvider>
        )}
      </Route>
    </Switch>
  )
}
